( function() {

  var youtube = document.querySelectorAll( ".youtube" );
  
  for (var i = 0; i < youtube.length; i++) {
    
    var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/maxresdefault.jpg";
    
    var image = new Image();
        image.src = source;
        image.addEventListener( "load", function() {
          youtube[ i ].appendChild( image );
        }( i ) );
    
        youtube[i].addEventListener( "click", function() {

          var iframe = document.createElement( "iframe" );

              iframe.setAttribute( "frameborder", "0" );
              iframe.setAttribute( "allowfullscreen", "" );
              iframe.setAttribute( "allow", "autoplay" );
              iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&autoplay=1&iv_load_policy=3&cc_load_policy=1&modestbranding=1&origin=https:\/\/www.sp-connect.com&playsinline=1&controls=1&loop=0&enablejsapi=1&widgetid=1" );

              this.innerHTML = "";
              this.appendChild( iframe );
        } );  
  };
  
} )();

console.log('custom js');
(function($) {
  console.log('custom js - jquery part ');
  
  $(function() {
    console.log('custom js - jquery part - onload');
	var tagname = 'data-tags-' +  window.location.href.replace(/^.*\//, '').replace(/\?.*$/, '');
    
    
	var $items = $('.product-loop div['+tagname+']');

	$('.product-loop > h2').remove();
	var tags = {};

	$items.each(function () {
    	tags[$(this).attr(tagname)] = $(this).attr(tagname);
        
    	//$(this).removeClass('desktop-3 last tablet-half mobile-half first last');
	});
   
    var userLocale = Shopify.locale;
    var tagline = '';
    switch (userLocale){
      case 'de':
          tagline = "Erstelle dein persönliches Setup";
          break;
      case 'fr':
          tagline = "Crée ta propre configuration";
          break;
      case 'it':
          tagline = "Crea il tuo setup personale";
          break;
      case 'es':
          tagline = "Crea tu configuración personal";
          break;
      case 'nl':
          tagline = "Creëer je persoonlijke opstelling";
          break;
      default:
          tagline = "Create your personal setup";
    }

	for(var tagval in tags) {
      
      console.log(tagval);
      if (tagval === 'Sets' || tagval === 'Bundles') {
        $('.product-loop').append('<h2>' + tagval + ' - ' + tagline + '</h2>');
      }else{
		$('.product-loop').append('<h2>' + tagval + '</h2> ');
      }
		$('.product-loop div['+tagname+'="'+tagval+'"]').appendTo($('.product-loop'));
        $('.product-loop').addClass('product-css-grid');
	}

	//$('.product-loop.product-css-grid .product-index').removeClass('desktop-3 last tablet-half mobile-half first last');
    
  });
})(jQuery);	


function spUpdateDiscountMessage() {
  var codeCookieValue;
  var getCookie = function(name) {
   var value = "; " + document.cookie;
   var parts = value.split('; '+name+'=');
   if (parts.length == 2) return parts.pop().split(";").shift();
  };
  codeCookieValue = getCookie('discount_code');
  if(!codeCookieValue){
   console.log("No Discount Code");
  }
  if(codeCookieValue){
     console.log("Discount Code - " + codeCookieValue);
     $(".discount-message").each(function() {
     $(this).html("<div class='show-discount'> <i class='fa-solid fa-tag'></i> Your discount code <span><strong>" + codeCookieValue + "</strong></span> is activated. </div>");
   });
  }
}

(function($) {
  $(document).on('', spUpdateDiscountMessage);
  $(spUpdateDiscountMessage);
})(jQuery);	
